export const MARITAL_STATUS_OPTIONS = {
  MARRIED: "married",
  UNMARRIED: "unmarried",
  SEPARATED: "separated",
};

export const maritalStatusOptions = [
  { label: "Married", value: MARITAL_STATUS_OPTIONS.MARRIED },
  { label: "Unmarried", value: MARITAL_STATUS_OPTIONS.UNMARRIED },
  { label: "Separated", value: MARITAL_STATUS_OPTIONS.SEPARATED },
];
